var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('br'),_vm._v(" "),_c('bot-list',{attrs:{"bots":_vm.bots,"page-size":30,"title":_vm.title,"layout":"swipe"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }